export default {
    moves: 'Κινήσεις',
    time: 'Χρόνος',
    score: 'Σκορ',
    settings: 'Ρυθμίσεις',
    sounds: 'Ήχος',
    autocomplete: 'Αυτόματη συμπλήρωση',
    leftHanded: 'Αριστερόχειρας',
    newDeal: 'Νέο Μοίρασμα',
    design: 'Προσαρμογή',
    easy: 'Εύκολο',
    medium: 'Μέτριο',
    hard: 'Δύσκολο',
    expert: 'Ειδικός',
    master: 'Εξπέρ',
    random: 'Τυχαίο',
    rulesKlondikeURL: 'https://solitaires.com/gr/articles/how-to-play-solitaire/',
    cardHighlight: 'Επισήμανση κάρτας',
    rulesSpiderURL: 'https://solitaires.com/gr/articles/how-to-play-spider-solitaire/',
    rulesFreecellURL: 'https://solitaires.com/gr/articles/how-to-play-freecell-solitaire/',
    autoPlay: 'Αυτόματο παιχνίδι',
    noMagicNeeded: 'Δεν χρειάζεται Μαγικό Ραβδί—συνεχίστε το παιχνίδι μόνοι σας!',
    leaveFeedback: 'Αφήστε σχόλια',
    feedbackThankYou: 'Εκτιμούμε το σχόλιό σας!',
    feedbackError: 'Παρουσιάστηκε σφάλμα. Το μήνυμά σας δεν στάλθηκε.',
    thanksSubscribing: 'Ευχαριστούμε για την εγγραφή!',
};
